import bs58 from 'bs58';
import { VersionedTransaction, SendTransactionError, } from '@solana/web3.js';
/**
 * Executes a Solana swap transaction.
 * @param connection - The Solana connection object.
 * @param signedTransaction - The signed transaction object.
 * @returns An object containing the transaction hash, explorer URL, and error message (if any).
 */
export async function executeSolana({ connection, transactionString, awaitConfirmation = false, }) {
    try {
        console.log('Executing Order SOLANA Checking transaction signatures in executeSolana');
        //deserialize the signed transaction
        const signedTransaction = VersionedTransaction.deserialize(bs58.decode(transactionString));
        const rawTransaction = signedTransaction.serialize();
        let txid;
        try {
            console.log('Executing Order SOLANA Sending raw transaction in executeSolana');
            //simulate
            const simulateConfig = {
                sigVerify: true,
                commitment: 'confirmed',
            };
            const simulation = await connection.simulateTransaction(signedTransaction, simulateConfig);
            console.log('Executing Order SOLANA Transaction simulation:', simulation);
            if (simulation.value.err) {
                throw new Error(`Transaction simulation failed: ${JSON.stringify(simulation, null, 2)}`);
            }
            txid = await connection.sendRawTransaction(rawTransaction, {
                skipPreflight: false,
                maxRetries: 2,
                preflightCommitment: 'processed',
            });
            console.log('Executing Order SOLANA Transaction sent with ID:', txid);
        }
        catch (e) {
            if (e instanceof SendTransactionError) {
                console.log(' Executing Order SOLANA SendTransactionError encountered:');
                console.log(' Executing Order SOLANA Error message:', e.message);
                try {
                    // @ts-ignore
                    const logs = await e.getLogs();
                    console.log(' Executing Order SOLANA Detailed error logs:', logs);
                }
                catch (logError) {
                    console.log(' Executing Order SOLANA Error fetching logs:', logError);
                }
                console.log(' Executing Order SOLANA Error details:', e.message);
                throw e;
            }
            else {
                console.log('Executing Order SOLANA Error sending raw transaction:', e.message);
                throw e;
            }
        }
        // try {
        //   console.log('Confirming transaction:', txid);
        //   const confirmation = await connection.confirmTransaction(txid, 'processed');
        //   console.log('Transaction confirmed:', confirmation);
        // } catch (e) {
        //   console.log(' Executing Order SOLANA Error confirming transaction:', e);
        //   return {
        //     txHash: txid,
        //     explorerUrl: `https://solscan.io/tx/${txid}`,
        //     error: `Transaction sent but confirmation failed: ${
        //       e instanceof Error ? e.message : String(e)
        //     }`,
        //   };
        // }
        return {
            txHash: txid,
            explorerUrl: `https://solscan.io/tx/${txid}`,
            error: null,
        };
    }
    catch (e) {
        console.log('Executing Order SOLANA Unexpected error in executeSolana:', e);
        return {
            txHash: null,
            explorerUrl: null,
            error: e instanceof Error ? e.message : String(e),
        };
    }
}
